const HOT_ORDER = [
  'constitution.md',
  'current-state.md',
  'strategy.md',
  'tasks.md',
];

function fileNode(path) {
  return { type: 'file', path, label: path.split('/').pop() };
}

function nestFolders(paths, prefix) {
  const folders = new Map();
  const files = [];
  for (const path of paths) {
    const rest = prefix ? path.slice(prefix.length) : path;
    const slash = rest.indexOf('/');
    if (slash === -1) {
      files.push(fileNode(path));
      continue;
    }
    const name = rest.slice(0, slash);
    const folderPath = prefix ? `${prefix}${name}` : name;
    if (!folders.has(folderPath)) folders.set(folderPath, []);
    folders.get(folderPath).push(path);
  }
  const nodes = [
    ...[...folders.entries()].map(([path, children]) => ({
      type: 'folder',
      path,
      label: path.split('/').pop(),
      isPackage: !path.startsWith('diary'),
      children: nestFolders(children, `${path}/`),
    })),
    ...files,
  ];
  return nodes;
}

export function buildMemoryTree(files) {
  const paths = [...new Set((files || []).map((file) => file.path).filter(Boolean))].sort();
  const hot = HOT_ORDER.filter((path) => paths.includes(path)).map(fileNode);
  const indexes = paths.filter((path) => path === 'index.md' || path === 'index-cold.md').map(fileNode);
  const recent = paths.includes('recent.md') ? [fileNode('recent.md')] : [];
  const diary = paths.filter((path) => path.startsWith('diary/'));
  const used = new Set([...HOT_ORDER, 'index.md', 'index-cold.md', 'recent.md', ...diary]);
  const packages = paths.filter((path) => !used.has(path));

  const sections = [];
  if (hot.length) sections.push({ type: 'section', label: 'Hot', children: hot });
  if (indexes.length) sections.push({ type: 'section', label: 'Indexes', children: indexes });
  if (recent.length) sections.push({ type: 'section', label: 'Recent', children: recent });
  if (diary.length) {
    sections.push({ type: 'section', label: 'Diary', children: nestFolders(diary, '') });
  }
  if (packages.length) {
    sections.push({ type: 'section', label: 'Packages', children: nestFolders(packages, '') });
  }
  return sections;
}
